var _excluded = ["className", "alt", "src", "dataSpacer", "onLoadErrorPath", "loading", "component"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { string, oneOf, elementType } from "prop-types";
import classNamesMaker from "classnames";
import styles from "./image.module.css";
export var BOX_SIZES = {
  TINY: "tiny",
  SMALL: "small",
  MEDIUM: "medium",
  BIG: "big",
  LARGE: "large"
};
export var LOADING_VALUES = {
  LAZY: "lazy",
  // Defer loading of images until some conditions are met
  EAGER: "eager" // Loads an image immediately
};
export var Image = /*#__PURE__*/function (_React$PureComponent) {
  function Image() {
    var _this;
    _classCallCheck(this, Image);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Image, [].concat(args));
    _defineProperty(_this, "count", 0);
    _defineProperty(_this, "onLoadError", function (event) {
      var onLoadErrorPath = _this.props.onLoadErrorPath;
      if (_this.count < 2) {
        // eslint-disable-next-line no-param-reassign
        event.currentTarget.src = onLoadErrorPath;
        _this.count = _this.count + 1;
      }
    });
    return _this;
  }
  _inherits(Image, _React$PureComponent);
  return _createClass(Image, [{
    key: "getCustomAttributes",
    value: function getCustomAttributes() {
      var _this$props = this.props,
        alt = _this$props.alt,
        src = _this$props.src,
        dataSpacer = _this$props.dataSpacer,
        onLoadErrorPath = _this$props.onLoadErrorPath;
      return _objectSpread(_objectSpread({
        alt: alt,
        // `img` should always have an alt attribute for a11y purpose
        src: src
      }, onLoadErrorPath ? {
        onError: this.onLoadError
      } : {}), dataSpacer && dataSpacer.length > 0 ? {
        "data-spacer": dataSpacer
      } : {});
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        alt = _this$props2.alt,
        src = _this$props2.src,
        dataSpacer = _this$props2.dataSpacer,
        onLoadErrorPath = _this$props2.onLoadErrorPath,
        loading = _this$props2.loading,
        Component = _this$props2.component,
        restProps = _objectWithoutProperties(_this$props2, _excluded);

      /*
        The HTML `alt` attribute is handle by this.getCustomAttributes().
        We can therefore disable the corresponding eslint rule.
      */
      /* eslint-disable-next-line jsx-a11y/alt-text */
      return /*#__PURE__*/React.createElement(Component, _extends({}, restProps, this.getCustomAttributes(), {
        className: classNamesMaker(styles["jds-Image"], className),
        loading: loading
      }));
    }
  }]);
}(React.PureComponent);
Image.defaultProps = {
  alt: "",
  className: "",
  dataSpacer: null,
  loading: LOADING_VALUES.LAZY,
  onLoadErrorPath: "",
  component: "img"
};
Image.propTypes = {
  alt: string,
  className: string,
  component: elementType,
  dataSpacer: string,
  loading: oneOf(Object.values(LOADING_VALUES)),
  onLoadErrorPath: string,
  src: string.isRequired
};